/* tslint:disable:no-any */
import { KnownError } from './known.error';

/**
 * Error to be emitted for empty OAuth login error responses.
 */
export class OAuthLoginError extends KnownError<any> {
  public readonly name: string = 'OAuthLoginError';
}
